import { render } from "./RecentActivityCard.vue?vue&type=template&id=15574d29&scoped=true&ts=true"
import script from "./RecentActivityCard.vue?vue&type=script&lang=ts"
export * from "./RecentActivityCard.vue?vue&type=script&lang=ts"

import "./RecentActivityCard.vue?vue&type=style&index=0&id=15574d29&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15574d29"]])

export default __exports__